/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DivisionItem { 
    /**
     * number of a meter
     */
    meterNumber?: string;
    name?: string;
    /**
     * is true if it is a smart-meter, default false
     */
    imsys?: boolean;
}

